// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2231":"47672de5","3690":"0593339e","4924":"cd35db14","5006":"b2ca8117"}[chunkId] + ".css";
};